/*eslint-disable */
import React, { Component } from 'react'
import Loader from 'react-loader'

export default class Performance extends Component {
  componentDidMount() {
    const { semesterId, courseId } = this.props.match.params
    this.props.fetchProgressDetail(semesterId, courseId)
    this.props.fetchCourse(courseId)
  }
  render() {
    const { isLoading, progressDetail, course } = this.props
    return (
      <div className='uspex'>
        <Loader loaded={!isLoading} color='#7b2b2a'>
          <div className='captions'>Успеваемость</div>
          <div>
            <p className='name-lessons'>
              {course && course[0].title} <span>I семестр 2017-2018 учебного года</span>
            </p>
            <p>
              Преподаватель: <span className='prepod'>Самсонов Игорь Александрович</span>
            </p>
            <p>
              Проведено уроков:<span className='prepod'>42</span>
            </p>
          </div>
          <table>
            <tr>
              <th className='table-title'>Дата</th>
              <th className='table-title'>
                Тип
                <br />
                занятия
              </th>
              <th className='table-title'>Тема занятия</th>
              <th className='table-title'>Домашнее задание</th>
              <th className='table-title'>Оценки</th>
              <th className='table-title'>Комментарии</th>
            </tr>
            {progressDetail.length > 0 &&
              progressDetail.map((detail, index) => (
                <tr>
                  <td className='td-center'>{detail.lessonfulldate_txt}</td>
                  <td>{detail.lessontype}</td>
                  <td className='mr-b'>{detail.otitle}</td>
                  <td>{detail.homeworktext}</td>
                  <td className='td-center'>{detail.grade}</td>
                  <td>{detail.gradecomment}</td>
                </tr>
              ))}
          </table>
        </Loader>
      </div>
    )
  }
}
